angular
  .module 'memberPortal'
  .controller 'PerformWorkoutCtrl', (
    $scope,
    $rootScope,
    $stateParams,
    $state,
    $modal,
    Restangular,
    UnitSymbols,
    WorkoutService,
    DataService,
    workout
  ) ->
    $scope.pageParams = {}
    $scope.getHash = ->
      $stateParams.hash || $stateParams.m

    $scope.manageable = workout.manageable_by_member
    $scope.unitSymbols = UnitSymbols
    $scope.exercises = Restangular.all('exercises').getList(count: 2000).$object

    $scope.notDisplayOnly = (exercise) ->
      exercise.exercise_type isnt 'display_only'

    pingIntervalId = window.setInterval ->
      Restangular.all('members').customGET('ping')
    , 120000

    unsubscribe = $rootScope.$on '$stateChangeStart', () ->
      window.clearInterval(pingIntervalId) if pingIntervalId
      unsubscribe()

    recalculateWorkoutPosition = ->
      recalculatePosition $scope.workout.performed_workout_exercises_attributes
      $scope.workout.performed_workout_exercises_attributes.forEach (exercise) ->
        recalculatePosition exercise.performed_workout_sets_attributes

    recalculatePosition = (collection) ->
      collection.forEach (item, index) ->
        if item._destroy
          removedItem = collection.splice(index, 1)[0]
          collection.push removedItem
      collection.forEach (item, index) ->
        item.position = index + 1

    $scope.addExercise = ->
      newExercise = $scope.pageParams.newExercise.plain()
      exercise =
        exercise_id: newExercise.id
        exercise_name: newExercise.name
        exercise_description: newExercise.description
        exercise_type: newExercise.exercise_type
        exercise_video_url: newExercise.video_url
        performed_workout_sets_attributes: [
          position: 1
          target_weight_unit: $scope.pageParams.targetWeightUnit
          target_distance_unit: $scope.pageParams.targetDistanceUnit
          actual_weight_unit: $scope.pageParams.targetWeightUnit
          actual_distance_unit: $scope.pageParams.targetDistanceUnit
        ]
      $scope.workout.performed_workout_exercises_attributes.push exercise
      $scope.pageParams.newExercise = undefined
      recalculateWorkoutPosition()

    $scope.removeExercise = (index) ->
      exercise = $scope.workout.performed_workout_exercises_attributes[index]
      if exercise.id
        exercise._destroy = 1
      else
        $scope.workout.performed_workout_exercises_attributes.splice(index, 1)
      recalculateWorkoutPosition()

    $scope.addSet = (exerciseIndex) ->
      firstSet = $scope.workout
        .performed_workout_exercises_attributes[exerciseIndex]
        .performed_workout_sets_attributes[0]
      targetWeightUnit =
        firstSet?.target_weight_unit
      targetDistanceUnit =
        firstSet?.target_distance_unit
      exercise =
        $scope.workout.performed_workout_exercises_attributes[exerciseIndex]
      set =
        target_weight_unit: targetWeightUnit
        target_distance_unit: targetDistanceUnit
        actual_weight_unit: targetWeightUnit
        actual_distance_unit: targetDistanceUnit
      exercise.performed_workout_sets_attributes.push set
      recalculateWorkoutPosition()

    $scope.removeSet = (exerciseIndex, setIndex) ->
      exercise =
        $scope.workout.performed_workout_exercises_attributes[exerciseIndex]
      set = exercise.performed_workout_sets_attributes[setIndex]
      if set.id
        set._destroy = 1
      else
        exercise.performed_workout_sets_attributes.splice(setIndex, 1)
      recalculateWorkoutPosition()

    $scope.isRemoveAvailable = (collection) ->
      $scope.manageable && _.filter(collection, (item) -> !item._destroy).length > 1

    $scope.playExercise = (exercise) ->
      modalInstance = $modal.open
        template: require('templates/member_portal/workouts/workout_video_modal.html.slim')
        size: 'lg'
        resolve:
          exercise: -> exercise
        controller: ($scope, $modalInstance, exercise) ->
          $scope.exercise = exercise
          $scope.cancel = ->
            $modalInstance.dismiss('cancel')

    $scope.getPersonalBest = (exercise) ->
      WorkoutService.getPersonalBest(exercise.personal_best)

    parseTimeItem = (item) ->
      if item
        itemText = item.toString()
        if itemText.length is 1 then '0' + itemText else itemText
      else
        '00'

    $scope.onTimeChanged = (set, type) ->
      time = set["#{type}_time"]
      timeArray = time.split(':').map (item) -> parseTimeItem(item)
      set["#{type}_hours"] = timeArray[0]
      set["#{type}_minutes"] = timeArray[1]
      set["#{type}_seconds"] = timeArray[2]

    $scope.formatTimeField = (set, type) ->
      hours = parseTimeItem set["#{type}_hours"]
      minutes = parseTimeItem set["#{type}_minutes"]
      seconds = parseTimeItem set["#{type}_seconds"]
      set["#{type}_time"] =
        if hours && minutes && seconds
          [hours, minutes, seconds].join(':')
        else
          undefined

    $scope.hitTarget = (set, type) ->
      if type is 'reps'
        set.actual_reps = set.target_reps
      if type in ['weight_and_reps', 'weight_reps_time_distance']
        set.actual_reps = set.target_reps
        set.actual_weight = set.target_weight
      if type in ['time_or_distance', 'weight_reps_time_distance']
        set.actual_distance_number = set.target_distance_number
        set.actual_hours = set.target_hours
        set.actual_minutes = set.target_minutes
        set.actual_seconds = set.target_seconds
        $scope.formatTimeField(set, 'actual')

    $scope.displayHitTarget = (set, type) ->
      weightAndReps = (set.target_reps || set.target_weight) &&
        !(set.actual_reps || set.actual_weight)
      timeOrDistance = (set.target_distance_number || set.target_hours ||
        set.target_minutes || set.target_seconds
      ) && !( set.actual_distance_number || set.actual_hours ||
        set.actual_minutes || set.actual_seconds
      )

      switch type
        when 'reps'
          set.target_reps && !set.actual_reps
        when 'weight_and_reps'
          weightAndReps
        when 'time_or_distance'
          timeOrDistance
        when 'weight_reps_time_distance'
          weightAndReps && timeOrDistance

    $scope.save = ->
      $scope.isLoading = true
      $scope.isError = false
      Restangular.all('performed_workouts').post($scope.workout).then (data) ->
        DataService.member_details.workout_history_available = true
        $state.go 'memberPortal.performedworkouts', m: $scope.getHash()
      , () ->
        $scope.isLoading = false
        $scope.isError = true

    prepareWorkout = (workout) ->
      firstSet = workout.workout_exercises[0]?.workout_sets[0]
      $scope.pageParams.targetWeightUnit =
        firstSet?.target_weight_unit
      $scope.pageParams.targetDistanceUnit =
        firstSet?.target_distance_unit
      w = workout.clone()
      w.performed_workout_exercises_attributes =
        w.workout_exercises.map (exercise) ->
          exercise.performed_workout_sets_attributes =
            exercise.workout_sets.map (set) ->
              set.contact_workout_set_id = set.id
              set.actual_distance_unit = set.target_distance_unit
              set.actual_weight_unit = set.target_weight_unit
              $scope.formatTimeField(set, 'target')
              set.id = undefined
              set
          exercise.contact_workout_exercise_id = exercise.id
          exercise.id = undefined
          exercise.workout_sets = undefined
          exercise
      w.contact_workout_id = w.id
      w.id = undefined
      w.workout_exercises = undefined
      w.contact = undefined
      w.contact_id = undefined
      w.rootObjectName = 'performed_workout'
      w

    $scope.workout = prepareWorkout(workout)
